<template>
  <div>
    <div>
      <b-field label="Remit To">
        <b-select
          v-model="location"
          placeholder="Select Location"
          :loading="loading"
          expanded
          size="is-medium"
          @input="announce">
          <option v-for="location in locations" :value="location" :key="location.id">
            {{ location.nickname }}
          </option>
        </b-select>
      </b-field>
      <div>
        <p v-if="location !== null" class="has-text-grey is-size-7">
          {{ location.address.street1 }}
          {{ location.address.street2 }}
          {{ location.address.city }}, {{ location.address.province }}
          {{ location.address.postal_code }}
        </p>
        <p v-else-if="!loading && locations.length === 0" class="has-text-danger is-size-7">
          No locations found! Please add your
          <router-link :to="{ name: 'settings.general' }" class="has-text-info">billing address.</router-link>
        </p>
        <p v-else-if="!loading && locations.length > 0" class="has-text-grey-light is-size-7">
          Select a location above...
        </p>
        <p v-else class="has-text-grey-light is-size-7">
          Loading locations...
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  components: {

  },
  computed: {
    ...mapGetters(['context']),
    endpoint () {
      return this.context.route + '/locations/?type=billing'
    }
  },
  data () {
    return {
      loading: true,
      errors: [],
      locations: [],
      location: null
    }
  },
  methods: {
    load () {
      this.loading = true
      this.$http.get(this.endpoint).then(response => {
        this.locations = response.data.results
        this.loading = false
        if (this.locations.length === 1) {
          this.location = this.locations[0]
        }
      })
    },
    announce () {
      this.$emit('input', this.location)
    }
  },
  mounted () {
    this.load()
  },
  watch: {
    location (value) {
      if (value !== null) {
        this.$emit('input', this.location)
      }
    }
  }
}
</script>
